module.exports = __webpack_public_path__ + "static/media/slide6.84e59368.jpg";